import numeral from 'numeral';

export const formatPrice = (
  price: number | null,
  chargeback: boolean,
  subtotal: boolean,
) => {
  if (!price) return '';
  if (subtotal) return '';
  if (chargeback) return `${price}%`;

  return numeral(price).format('$0,0.00');
};
